module.exports = __webpack_public_path__ + "img/logo-17.03c268fd.png";